import styled from 'styled-components';
import { flexbox, space } from 'styled-system';
import { deviceMediaQueries } from '../../theme';
var Grid = /*#__PURE__*/styled.div.withConfig({
  displayName: "grid__Grid",
  componentId: "x31v0u-0"
})(["margin-right:auto;margin-left:auto;max-width:", "px;", ";", ";", "{padding:0 ", "px;}", "{padding:0 ", "px;}", "{padding:0 ", "px;}"], p => p.theme.grid_max_width, flexbox, space, deviceMediaQueries.mobile, p => p.theme.mobile.grid_outer_spacing, deviceMediaQueries.tablet, p => p.theme.tablet.grid_outer_spacing, deviceMediaQueries.desktop, p => p.theme.desktop.grid_outer_spacing);
export default Grid;